// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper_18PRh","countdown":"index_countdown_1D9co"};